(function () {
  "use strict";

  angular.module("tm.navButtonsThreeStack")
    .directive("tmNavButtonsThreeStack", function() {
      return {
        template: require("./tmNavButtonsThreeStack.html"),
        link,
        restrict: "E",
        scope: {
          // Show Company Admin button only for Company Admin, Partner, Support accounts
          showCompanyAdmin: "=",
          goToCompanyAdmin: "&"
        }
      };
    });

  function link(scope, element, attrs) {}
})();



// WEBPACK FOOTER //
// ./~/@trimblemaps/webtools-common/javascript/AngularJS/tm-nav-buttons-three-stack/tmNavButtonsThreeStack.directive.js